import React from "react";
import styled from "styled-components";

export interface PlayerProps extends React.VideoHTMLAttributes<HTMLVideoElement> {
    src?: string;
    url?: string; // Alias for src
    autoplay?: boolean;
    controls?: boolean;
    loop?: boolean;
}

const PlayerRoot = styled.video<PlayerProps>`
    width: 100%;
    max-width: 100%;
    height: auto;
`;

export const Player: React.FC<PlayerProps> = ({ src, url, autoplay, controls = true, loop, ...props }) => {
    const videoSrc = src || url;
    return (
        <PlayerRoot src={videoSrc} autoPlay={autoplay} controls={controls} loop={loop} {...props}>
            Your browser does not support the video tag.
        </PlayerRoot>
    );
};

export default Player;


